import React from 'react';
import PropTypes from 'prop-types';
import { PageLevelNotification } from '@americanexpress/dls-react';

const ErrorMessage = ({ message }) => (
  <PageLevelNotification className="margin-0" type="caution" isDismissible={false}>
    <div>{message}</div>
  </PageLevelNotification>
);

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorMessage;
